import { createAsyncThunk } from '@reduxjs/toolkit';
const base = process.env.REACT_APP_API_URL + '/staff-training';
async function request(path, options, api) {
  try {
    const response = await fetch(base + path, { ...options, signal: api.signal, headers: {
      'Content-Type': 'application/json', Authorization: 'Bearer ' + localStorage.getItem('token'),
    } });
    const result = await response.json();
    if (!response.ok) throw new Error(result.message || 'Unable to load training records.');
    return result.data;
  } catch (error) { return api.rejectWithValue(error.message); }
}
export const fetchTrainingDashboard = createAsyncThunk('staffTraining/dashboard', (date, api) => request('/dashboard?' + new URLSearchParams({ date }), {}, api));
export const fetchTrainingCategories = createAsyncThunk('staffTraining/categories', (_, api) => request('/categories', {}, api));
export const fetchTrainingStaff = createAsyncThunk('staffTraining/staff', (_, api) => request('/staff', {}, api));
export const fetchTrainingRecord = createAsyncThunk('staffTraining/record', (id, api) => request('/records/' + encodeURIComponent(id), {}, api));
export const fetchTrainingHistory = createAsyncThunk('staffTraining/history', (staffId, api) => request('/records?' + new URLSearchParams({ staffId }), {}, api));
export const saveTrainingRecord = createAsyncThunk('staffTraining/save', ({ id, data }, api) => request('/records' + (id ? '/' + encodeURIComponent(id) : ''), { method: id ? 'PUT' : 'POST', body: JSON.stringify(data) }, api));
